<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import CheckUnsaveChange from '@/components/shared/CheckUnsaveChange'
import AdminForm from '@/components/admin/AdminForm.vue'
import { AloDbGlider } from '@/models/alodb/AloDbGlider'
import AdminGliderForm from '@/components/admin/glider/AdminGliderForm.vue'
import { SecurityItemsKeys } from '@/enum/SecurityItems'

@Component({
  name: 'AdminGlider',
  components:{AdminGliderForm}
})
export default class AdminGlider extends AdminForm<AloDbGlider> {  
 
  created() {                            
    if(!this.$store.myGetters.userSecurity[SecurityItemsKeys.ADMIN_GLIDER].enable) {
      this.canRender = false       
      this.$router.push('/')
    }     
  }
  
  get itemTypeName(){
    return "Glider"
  }

  get showTitle(){
    return false
  }

  get originalLibelle(){
    return this.original.GLI_LIBELLE
  }

}
</script>